export default "__VITE_ASSET__c4ed5bc0__"